import { useEffect, useState } from 'react';
import { tasteApi, type Taste } from '../api';

/** Smaakprofiel: favoriete genres, kijkgewoontes en meest bekeken titels (90 dagen). */
export function TasteProfile({ load, mine = false }: { load: () => Promise<Taste>; mine?: boolean }) {
  const [t, setT] = useState<Taste | null>(null);
  const [err, setErr] = useState(false);
  useEffect(() => {
    load().then(setT).catch(() => setErr(true));
  }, []);
  if (err) return <p className="subtle">Smaakprofiel ophalen mislukt.</p>;
  if (!t) return <p className="subtle" aria-busy="true">Kijkgeschiedenis bekijken…</p>;
  if (!t.plays) return <p className="subtle">Nog te weinig gekeken in de afgelopen 90 dagen om iets te zeggen.</p>;
  const max = t.genres[0]?.pct || 1;
  const h = t.habits;
  const habits: [string, string][] = [
    ['Meest actief', [h.days.join(' en '), h.partOfDay ? `'s ${h.partOfDay === 'nacht' ? 'nachts' : h.partOfDay === 'avond' ? 'avonds' : h.partOfDay === 'middag' ? 'middags' : 'ochtends'}` : ''].filter(Boolean).join(', ') || '—'],
    ['Films of series', `${h.moviesPct} / ${h.episodesPct}`],
    ['Afleveringen per dag', h.perEvening != null ? String(h.perEvening).replace('.', ',') : '—'],
    ['Via addons', `${h.addonPct}%`],
  ];
  return (
    <div className="taste">
      <span className="subtle">{t.plays} keer gekeken, {t.titles} titels · laatste 90 dagen{t.plexAvailable ? '' : ' (zonder Plex-geschiedenis)'}</span>
      <ul className="taste-genres" aria-label="Favoriete genres">
        {t.genres.map((g) => (
          <li key={g.name}>
            <span className="taste-g-name">{g.name}</span>
            <span className="ov-bar" aria-hidden="true"><span style={{ width: `${Math.round((g.pct / max) * 100)}%`, background: '#4da3ff' }} /></span>
            <span className="taste-g-pct">{g.pct}%</span>
          </li>
        ))}
      </ul>
      <div className="taste-habits">
        {habits.map(([k, v]) => (
          <div key={k}><span className="subtle">{k}</span><strong>{v}</strong></div>
        ))}
      </div>
      {t.top.length > 0 && (
        <div className="taste-top">
          <span className="subtle">Meest bekeken</span>
          <ol>{t.top.map((x) => <li key={x.title}><span>{x.title}</span><span className="subtle">{x.plays}×</span></li>)}</ol>
        </div>
      )}
      {mine && <p className="subtle hint">De beheerder van deze server kan dit smaakprofiel ook zien.</p>}
    </div>
  );
}

export function MyTaste() {
  return (
    <section className="settings-block" aria-label="Mijn smaakprofiel">
      <h2>Mijn smaakprofiel</h2>
      <TasteProfile load={tasteApi.mine} mine />
    </section>
  );
}
